import type { MerchantApiClient } from "../../types.js";
import type { StoreSettingsDraft, StoreSettingsProfile } from "./models.js";

interface DataEnvelope<T> {
  data: T;
  meta: { requestId: string };
}

export interface StoreSettingsApi {
  getStore(): Promise<StoreSettingsProfile>;
  updateStore(draft: StoreSettingsDraft, idempotencyKey: string): Promise<StoreSettingsProfile>;
}

export function createStoreSettingsApi(client: MerchantApiClient): StoreSettingsApi {
  return {
    async getStore() {
      return (await client.get<DataEnvelope<StoreSettingsProfile>>("/v1/api/store")).data;
    },
    async updateStore(draft, idempotencyKey) {
      return (
        await client.patch<DataEnvelope<StoreSettingsProfile>>(
          "/v1/api/store",
          {
            businessHours: draft.businessHours,
            reviewSlaMinutes: draft.reviewSlaMinutes,
          },
          { idempotencyKey },
        )
      ).data;
    },
  };
}
